var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"c-action-banner px-4 align-items-center justify-content-between"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('h2',{staticClass:"h1 m-0 font-weight-bold text-light"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"auto"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }